module.exports = __webpack_public_path__ + "images/mywort/default-avatar.png";


//////////////////
// WEBPACK FOOTER
// ./images/mywort/default-avatar.png
// module id = 523
// module chunks = 93